import type Shape from '../objects/Shape';
import type Wireframe from '../objects/Wireframe';
import { AhaEditorUtils } from '@aha-app/aha-editor-v2';

type ColorableObject = Shape | Wireframe;

export function getTextColorFromSelection(selection: fabric.Object): string {
  return getTextColorFromObject(selection.firstObject());
}

export function getTextColorFromObject(object: ColorableObject): string {
  if ('readTextProperty' in object) {
    const color = object.readTextProperty(editor => {
      return AhaEditorUtils.Marks.allNodesHaveSameColor(editor);
    });

    if (color) {
      return color;
    }
  }

  return object.textColor ?? '#000000';
}
